import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	emptyAssessmentTitle: {
		id: 'fastshift.emptyAssessmentTitle',
		defaultMessage: 'You have no assessment data for this organisation',
		description: 'Title displayed when no assessments are available.',
	},
	emptyAssessmentDescription: {
		id: 'fastshift.emptyAssessmentDescription',
		defaultMessage:
			'First step on the journey to Cloud is to assess your Data Center instances and understand their Cloud readiness. Follow the link to start the process.',
		description:
			'Description displayed when no assessments are available, prompting the user to create one.',
	},
	startAssessmentButton: {
		id: 'fastshift.startAssessmentButton',
		defaultMessage: 'Start assessment',
		description: 'Button text to initiate a new assessment.',
	},
	learnMoreLink: {
		id: 'fastshift.learnMoreLink',
		defaultMessage: 'Learn more about assessments',
		description: 'Link text to provide more information about assessments.',
	},
});
